<template>
  <div class="libraryContent">
    <div class="onlineNav">
       <headers/>
       <div class="searchNav">
            <h1>海量GMAT题库 未付费学员即可免费解锁80%海量题库</h1>
            <div class="titTag"><a class="scoreTag">题库总题数9000+</a><a>做题总人数3000+</a><a class="scoreLast">平均每天做题人数2000+</a></div>
            <div class="searchInput"><input placeholder="搜索包含以下来源：OG GWD Manhattan 破解版07/08/12等试题" /></div>
            <div class="searchText">皮毛联盟GMAT题库搜题工具已包含以下题源：OG PREP GWD Manhattan 机经······</div>
       </div>
    </div>
    <div style="width: 1400px;margin: 0 auto;margin-top: 30px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/questionStock' }">题库</el-breadcrumb-item>
        <el-breadcrumb-item>推理IR</el-breadcrumb-item>
        <el-breadcrumb-item>题目</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="libraryCon">
      <div class="libraryConLeft">
        <!-- 题目内容 -->
        <div class="ConLeftNav">
          <h2>题目内容</h2>
          <div class="subjectCard">
              <div v-html="objContent.title"></div>
              <div v-html="objContent.stem"></div>
              <p v-for="(answer,indexer) in objContent.answer" :key="indexer">{{answer}}</p>
          </div>
          <div class="ConLeftNavUnder">
            <p>正确答案:<a v-for="(items,indexs) in objContent.ranswer" :key="indexs">{{items}}</a></p>
            <div>查看答案</div>
          </div>
        </div>
        <!-- 精选解析 -->
        <div class="LeftanalysisOne">
          <div class="LeftanalysisCon">
            <h1>精选解析</h1>
            <div class="analysisText" v-html="objContent.analysis"></div>
            <div class="analysisBtn">
              <div><img src="../../assets/pariseHelp.png"><a>觉得很赞</a></div>
              <div class="noHelp"><img src="../../assets/noHelp.png"><a>没帮助</a></div>
            </div>
          </div>
        </div>
        <!-- 讨论 -->
        <div class="Leftanalysis">
          <div class="LeftanalysisCon">
            <!-- 输入评论 -->
            <div class="analysisDiscussUser">
                <img src="../../assets/allSubject/userPicture.png"><p class="userNickname">画画撒大针对SC题目</p><p>已输入{{userInputScore}}个字</p>
            </div>
            <textarea type="text" class="inputs" v-model="userInput" placeholder="我要讨论/提问  (限400字)" maxlength="400" />
            <div class="userBtns">
                <el-checkbox v-model="checked" radio>标记为提问，会有更大神为你解答</el-checkbox>
                <button>发送</button>
              </div>
              <h1>问题讨论</h1>
              <!-- 用户评论 -->
              <div class="discussCards">
                <div class="discussCardsNav">
                  <img src="../../assets/allSubject/userPicture.png"><p>画画撒大针对SC题目</p>
                </div>
                <div class="discussCardsCon">
                  <p>句子结构：在……ECS期间，坚定的倡导者……通过暗示…… 。A就像她当时那样..没有同位语简洁，在她的建议下，她的建议里被建议的丑闻很多支持者，也没有通过暗示，这么个动作更好一点，只能对比出来 </p>
                  <p>A 正确1</p>
                  <p>B 正确2</p>
                  <p>C 正确3</p>
                  <p>D 正确4</p>
                  <div class="pariseNews">
                    <div class="parise">
                      <div class="parise"><img src="../../assets/parise.png"><p>1353</p></div>
                      <div  class="parise" style="margin-left: 25px;"><img src="../../assets/news.png"><p>回复</p></div>
                    </div>
                    <span>2014-12-02 09:10:20</span>
                  </div>
                </div>
              </div>
              <!-- 回复 -->
              <div class="discussCardsCon CardConsTop">
                <div class="discussCardsNav">
                  <img src="../../assets/allSubject/userPicture.png">
                  <p>54465441</p><p>回复</p><p>画画撒大针对SC题目</p>
                </div>
                <p class="CardConsTopInfos">句子结构：在……ECS期间，坚定的倡导者……通过暗示……。A就像她当时那样..没有同位语简洁，在她的建议下，在她的建议里被建议的丑闻很多支持者，也没有通过暗示，                     这么个动作更好一点只能对比出来B的后面结构太复杂C尴尬D正确E she双主语</p>
                <div class="pariseNews CardConsTopInfos">
                  <div class="parise">
                    <div class="parise"><img src="../../assets/parise.png"><p>1353</p></div>
                    <div class="parise" style="margin-left: 25px;"><img src="../../assets/news.png"><p>回复</p></div>
                  </div>
                  <span>2014-12-02 09:10:20</span>
                </div>
              </div>
              <!-- 回复框 -->
              <div class="userReply">
                <textarea type="text" class="inputs" v-model="userReply" placeholder="我要回复  (限400字)" maxlength="400" />
                <div class="userBtns">
                  <button>取消</button>
                  <button class="sendOut">发送</button>
                </div>
              </div>
        </div>
      </div>
      </div>
     <!-- 右侧 -->
      <div class="libraryConRight">
        <div class="rightCardOne">
          <div class="CardOneCon">
            <div class="CardOneConUnder">
              <h1>题目来源</h1>
              <div>{{value}}</div>
              <div class="CardOneConUnderBtns">
                <p>正确率：{{objContent.average}}%</p>
                <div class="CardEvaluates">
                  <p>困难度:</p>
                  <div class="Cardevaluate">{{objContent.difficulty | difficult}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightCardTwo">
          <div class="rightCardTwoCon">
            <h1>最新提问</h1>
            <div class="CardTwoContent" v-for="(item,index) in 8" :key="index">
              <img src="../../assets/allSubject/userPicture.png">
              <div><p>画画撒大针对SC题目</p><p class="CardTwounder">发表了一个提问<span>去解答>></span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../api/subject.js'
  import headers from '../../components/header.vue'
  import searchNav  from  '../../components/searchNav.vue'
  export default{
    components:{
      headers,searchNav
    },
    data(){
      return{
        navCodes:require('@/assets/login/whiteCode.png'),
         headerIcon:require('@/assets/bottom/bottomIcon.png'),
        checked:false,
        //用户输入
        userInput:'',
        //用户回复
        userReply:'',
        //用户输入字体的个数
        userInputScore:0,
        options: [
           {value: 'PREEP07 Test 11',label: 'PREEP07 Test 1'},
           {value: 'PREEP07 Test 2',label: 'PREEP07 Test 2'},
        ],
        value: '',
        optionsTwo:[
          {value: 'SC',label: 'SC'},
          {value: 'DZ',label: 'DZ'}
        ],
        valueTwo:'',
        subjectId:null,
        objContent:{}
      }
    },
    watch:{
      userInput(oldVal,newVal){
        this.userInputScore = oldVal.length
      }
    },
    // watch:{
    //   userInput(newVal,oldVal){
    //     this.userInputScore = newVal.length
    //   }
    // },
    filters:{
      difficult(i){
        switch(i){
          case 0 : return '简单';
          case 1 : return '一般';
          case 2 : return '困难'
        }
      }
    },
    methods:{
    },
    mounted() {
      // if(this.$route.params.id){
      //   this.getData()
      // }
    }
  }
</script>

<style scoped>
  @import url("../../assets/css/libraryContent.css");
</style>



// WEBPACK FOOTER //
// src/view/questionBank/libraryContentTwo.vue